import JoinPremiumCheckoutScreen from '@/screens/join-premium/CheckoutScreen'

export default function () {
  return <JoinPremiumCheckoutScreen />
}
